
import BlacklistPanel from '@/components/setup/BlacklistPanel.vue'
import SetupSidebar from '@/components/setup/SetupSidebar.vue'

export default {
  name: 'SetupBlacklist',
  components: { BlacklistPanel, SetupSidebar },
  middleware: 'userAuth',
}
